<div class="toolbar">
  <span class="toolbar-search toolbar-search-wrapper">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        type="text"
        pInputText
        [(ngModel)]="searchUserName"
        (input)="onSearchUsername()"
        (keyup.enter)="onSearchUsername()"
        [placeholder]="'USERS.SEARCH_PLACEHOLDER' | translate"
        id="search-username"
        class="search-input"
      />
    </span>
    <button
      type="button"
      class="search-clear p-button p-button-text p-button-rounded"
      [class.visible]="searchUserName?.length"
      (click)="clearSearch()"
      [attr.aria-label]="'USERS.SEARCH_PLACEHOLDER' | translate"
    >
      <i class="pi pi-times"></i>
    </button>
  </span>
  <p-button
    label="{{ 'USERS.NEW' | translate }}"
    icon="pi pi-plus"
    (click)="newUser()"
  ></p-button>
  <p-button
    label="Eliminar seleccionados"
    severity="danger"
    (click)="deleteSelected()"
    *ngIf="selectedRecords?.length"
  ></p-button>
</div>

<p-table
  [value]="records$ | async"
  styleClass="p-datatable-striped"
  sortMode="single"
  [(selection)]="selectedRecords"
  dataKey="id"
  [paginator]="true"
  [rows]="limit"
  [rowsPerPageOptions]="[5, 10, 20, 50]"
  [lazy]="true"
  (onLazyLoad)="loadUsersLazy($event)"
  [totalRecords]="totalRecords"
  [sortField]="'createdAt'"
  [sortOrder]="-1"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="header-checkbox"></th>

      <th pSortableColumn="userName" id="header-username">
        {{ "USERS.USERNAME" | translate }}
        <p-sortIcon field="userName"></p-sortIcon>
        <p-columnFilter
          type="text"
          matchMode="contains"
          display="menu"
          field="userName"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
        />
      </th>

      <th pSortableColumn="role" id="header-role">
        {{ "USERS.ROLE" | translate }} <p-sortIcon field="role"></p-sortIcon>
        <p-columnFilter
          type="text"
          matchMode="contains"
          display="menu"
          field="role"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
        />
      </th>
      <th id="header-profiles">
        {{ "USERS.PROFILES" | translate }}
        <p-columnFilter
          type="text"
          matchMode="contains"
          display="menu"
          field="profiles"
          [showOperator]="false"
          [showAddButton]="false"
          [showMatchModes]="false"
        />
      </th>
      <th class="table-check" id="header-keycloak">
        {{ "USERS.KEYCLOAK" | translate }}
      </th>
      <th class="table-check" id="header-servolab">
        {{ "USERS.SERVOLAB" | translate }}
      </th>
      <th pSortableColumn="createdAt" class="table-date" id="header-createdAt">
        {{ "CREATED" | translate }} <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"
          ></button>
        </div>
      </td>
      <td>{{ record.userName }}</td>
      <td>{{ record.role }}</td>
      <td>{{ record.profiles }}</td>
      <td class="table-check">
        <i class="pi pi-check" *ngIf="record.keycloakId"></i>
      </td>
      <td class="table-check">
        <i class="pi pi-check" *ngIf="record.servolabId"></i>
      </td>
      <td class="table-date">
        {{ record.createdAt | date : "dd MMM yyyy, HH:mm" }}
      </td>
    </tr>
  </ng-template>
</p-table>
